import { Link } from "react-router-dom";

export default function ApplicationReceivedPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-white/[0.06]/30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-16">
            <Link to="/earlyaccess">
              <span className="font-heading text-xl font-bold text-white tracking-widest">DEALFORGE</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-lg text-center">
          <div className="w-16 h-16 border border-red-900/50 flex items-center justify-center mx-auto mb-10">
            <div className="w-3 h-3 bg-red-900/80" />
          </div>
          
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight">
            Founder Application Received.
          </h1>
          
          <p className="text-white/50 text-base leading-relaxed mb-4">
            Applications are reviewed weekly based on transaction volume, operational alignment, and infrastructure fit.
          </p>
          
          <p className="text-white/40 text-base leading-relaxed">
            If approved, onboarding details will be sent via email.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-white/[0.06]/30">
        <div className="text-center">
          <p className="text-white/30 text-sm tracking-wide">
            Private Beta Access • Limited Enrollment
          </p>
        </div>
      </footer>
    </div>
  );
}
